// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3Xogo","errorLogs":"EditorFooter_errorLogs__3spRk"};